import { render, staticRenderFns } from "./MoneyRecord.vue?vue&type=template&id=b0e2042c&scoped=true"
import script from "./MoneyRecord.vue?vue&type=script&lang=js"
export * from "./MoneyRecord.vue?vue&type=script&lang=js"
import style0 from "./MoneyRecord.vue?vue&type=style&index=0&id=b0e2042c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e2042c",
  null
  
)

export default component.exports